import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import Decimal from "decimal.js";
import Figure from "react-bootstrap/Figure";
import { API_PALLAS_URL } from "../ducks/consts";
import { ArrowBackIcon } from "../components/icons";
import Loading from "../components/Loading";
import toDecimalDisplay from "../utils/toDecimalDisplay";
import { Button, Table } from "react-bootstrap";
import toPriceDisplay from "../utils/toPriceDisplay";
import RequestBillButton from "../components/RequestBillButton";
import ComandaScan from "../containers/Selfcheckout/ComandaScan";
import useGoTo from "../hooks/useGoTo";

const ComandaDetalhes = ({ comanda }) => {
  if (!comanda.itens || !comanda.itens.length) {
    return <h4 className="type-h4 text-center my-3">SEM CONSUMO</h4>;
  }

  const totalProdutos = comanda.itens.reduce(
    (t, item) => t.plus(item.total_alt_it),
    new Decimal(0),
  );

  return (
    <div>
      <Table className="table-status">
        <thead>
          <tr>
            <th className="m-0 p-0">PRODUTO</th>
            <th className="m-0 p-0">QTD.</th>
            <th className="m-0 p-0 text-end">R$ TOTAL</th>
          </tr>
        </thead>
        <tbody>
          {comanda.itens.map((item, index) => (
            <tr key={`cached-product-${item.id}-${index}`}>
              <td className="m-0 pt-1 pb-1 px-0">
                <small>{item.desc_prod}</small>
              </td>
              <td className="m-0 pt-1 pb-1 px-0">
                <small>{item.qtd_it}</small>
              </td>
              <td className="m-0 pt-1 pb-1 px-0 text-end">
                <small>{toDecimalDisplay(item.total_alt_it, ",")}</small>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <div className="pe-3 ps-3">
        <p className="d-flex justify-content-between">
          <span>
            <strong>TOTAL PRODUTOS</strong>
          </span>
          <span>
            <strong>{toPriceDisplay(totalProdutos)}</strong>
          </span>
        </p>
      </div>

      <div className="pe-3 ps-3">
        <p className="d-flex justify-content-between">
          <span>
            <strong>TOTAL SERVIÇO</strong>
          </span>
          <span>
            <strong>{toPriceDisplay(comanda.servico_vlr_ped)}</strong>
          </span>
        </p>
      </div>

      <div className="pe-3 ps-3">
        <p className="d-flex justify-content-between">
          <span>
            <strong>TOTAL</strong>
          </span>
          <span>
            <strong>{toPriceDisplay(comanda.total)}</strong>
          </span>
        </p>
      </div>

      {(!comanda.pagamentos || comanda.pagamentos.length === 0) && (
        <p className="type-body text-center mb-3">NENHUM PAGAMETNO</p>
      )}

      {comanda.pagamentos && comanda.pagamentos.length > 0 && (
        <Table className="table-status">
          <tbody>
            {comanda.pagamentos.map((pag, index) => (
              <tr key={`cached-product-${pag.id}-${index}`}>
                <td className="m-0 pt-1 pb-1 px-0">{pag.nome}</td>
                <td className="m-0 pt-1 pb-1 px-0 text-end">
                  {toPriceDisplay(pag.valor)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <p className="type-body text-center mb-3">FIM</p>
    </div>
  );
};

function ComandaStatus() {
  const goto = useGoTo();
  const shop = useSelector((state) => state.shop);
  const comandaId = useSelector((state) => state.checkout.comandaId);
  const showOnlyStatus = useSelector((state) => state.appState.showOnlyStatus);
  const [loading, setLoading] = React.useState(true);
  const [comanda, setComanda] = React.useState(null);

  const { tableId } = shop;
  const name = comandaId ? "Comanda" : "Mesa";
  const cmdCod = comandaId ? comandaId : tableId.split("-")[2];

  useEffect(() => {
    const fetchComanda = async (shopId, cod_cmd) => {
      try {
        const response = await fetch(
          `${API_PALLAS_URL}/pdv_local/comandaAberta?lojaId=${shopId}&cod_cmd=${cod_cmd}`,
        );
        const json = await response.json();
        if (response.ok) {
          setComanda(json);
        } else {
          console.log(json);
        }
      } catch (err) {
        console.error(err);
        setComanda(null);
      } finally {
        setLoading(false);
      }
    };

    fetchComanda(shop.id, cmdCod);
  }, [shop.id, cmdCod]);

  const onBackClick = (event) => {
    goto("/");
  };

  const showDetalhes = !loading && comanda !== null;

  return (
    <div className="background-pattern">
      {/* {!showOnlyStatus && <CommonHeader text={`Consumo`} />} */}
      <div className="inloco-status">
        <div className="d-flex align-items-center">
          <Figure.Image
            src={shop.pictureUrl}
            alt="Logo da loja"
            className="my-4 fixed-logo-figure"
            width="150"
            height="150"
            roundedCircle
          />
          <h3 className="type-h3 text-center w-100">
            <strong>{name.toUpperCase()}</strong>
            <br />
            <strong>{cmdCod}</strong>
          </h3>
        </div>
        {loading && <Loading message="Carregando..." />}
        {!loading && comanda === null && (
          <p className="type-body text-center text-danger">
            {`Ocorreu um erro ao carragar o consumo da ${name.toUpperCase()} ${cmdCod}`}
          </p>
        )}
        {showDetalhes && <ComandaDetalhes comanda={comanda} />}
        <div className="d-flex justify-content-between">
          {!showOnlyStatus && (
            <Button
              className="my-3 p-3"
              variant="outline-dark"
              onClick={onBackClick}
            >
              <ArrowBackIcon className="me-2" />
              Voltar para o menu
            </Button>
          )}
          {showDetalhes && (
            <RequestBillButton shopId={shop.id} tableId={tableId} />
          )}
        </div>
      </div>
    </div>
  );
}

export default function InlocoStatusScreen() {
  const navigate = useNavigate();
  const shop = useSelector((state) => state.shop);
  const [scanned, setScanned] = React.useState(false);

  const moveStep = (next) => {
    if (next === false) {
      navigate(-1);
      return;
    }

    if (next === 1) {
      setScanned(true);
    }
  };

  if (shop.isSelfOrderScanQRCode && !scanned) {
    return (
      <div className="checkout-dialog-body-div">
        <ComandaScan step="STEP_Comanda" moveStep={moveStep} />
      </div>
    );
  }

  return <ComandaStatus />;
}
